import React from 'react';
import styled from 'styled-components';

import { Container, Row, Col } from './Grid';

const Code = styled.pre`
  background-color: #f5f5f5;
  border: #ddd;
  border-radius: 5px;
  padding: 1em;
`;

const Instructions = () => {
  return (
    <Container>
      <Row>
        <Col>
          <h3>Instructions</h3>
          <p>
            There are three options to choose when making assertions about
            the candidate code.
          </p>
          <ul>
            <li>
              <strong>Contain</strong>: asserts that 'Candidate' will contain all the tokens
              present in 'Structure'
              <Code>
                if for while
              </Code>
            </li>
            <li>
              <strong>Not Contain</strong>: asserts 'Candidate' will <strong>not</strong> contain
              any of the tokens present in 'Structure'
              <Code>
                if for while
              </Code>
            </li>
            <li>
              <strong>Match</strong>: Allows for much richer assertions. The structure of Candidate
              must match Structure exactly, with the exception of the wildcard '_'
              identifier which will match all candidate code
              <Code>
                {`(_, b) => {
  if (true) {
    for (let x = 0; x < 10; x++) {
      var _ = {
        'a': 'b',
      };
      const c = [function(_) { return 5 * _; }];
      var j = /match/g;
      var that = this;
    }
  }
}`}
              </Code>
              <p>
                Match supports the following features:
              </p>
              <ul>
                <li>IfStatement</li>
                <li>BlockStatement</li>
                <li>Program</li>
                <li>ExpressionStatement</li>
                <li>FunctionExpression</li>
                <li>ArrowFunctionExpression</li>
                <li>ForStatement</li>
                <li>WhileStatement</li>
                <li>BinaryExpression</li>
                <li>Literal</li>
                <li>VariableDeclaration</li>
                <li>VariableDeclarator</li>
                <li>ObjectExpression</li>
                <li>Property</li>
                <li>ArrayExpression</li>
                <li>ReturnStatement</li>
                <li>ThisExpression</li>
                <li>UnaryExpression</li>
                <li>UpdateExpression</li>
                <li>LogicalExpression</li>
                <li>Identifier</li>
              </ul>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default Instructions;



// WEBPACK FOOTER //
// ./src/Instructions.js